import actionTypes from '../../actionTypes'
import initial from '../../initial'

const payment = (state = initial.payment, action) => {
  switch (action.type) {
  case actionTypes.SET_PAYMENTS_PLAN:
    return { ...state, plan: action.payload }
  case actionTypes.SET_PLAN_LIMIT:
    return { ...state, planLimit: action.payload }
  case actionTypes.SET_PLAN_NOTICE_VISIBLE:
    return { ...state, planNoticeVisible: action.payload }
  default:
    return state
  }
}

export default payment
